import * as React from "react"
import { AutocompleteAsyncDebounced } from "@components"

import { BACKEND_APIS } from "@constants"
import { selectedBrand, tableData, totalCount } from "../@signals"
import { fetchSkusByBrand } from "../@hooks/useSkuManagement"


export default function SkuManagementBrandFilter() {
    const handleChange = (e) => {
        const value = e.target.value
        selectedBrand.value = value
        if (value) {
            fetchSkusByBrand(value)
        } else {
            tableData.value = []
            totalCount.value = 0
        }
    }

    return <AutocompleteAsyncDebounced
        urlAjax={`${BACKEND_APIS.BRANDS}/crud/brand/find-options`}
        label="Brand"
        placeholder="Select a brand to load SKUs..."
        value={selectedBrand.value}
        onChange={handleChange}
        queryParam="search"
    />
}
